import { Typography, useMediaQuery } from "@mui/material";
import { Stack } from "@mui/system";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ImageAssets from "../../../../assets";
import { MuiButton } from "../../../../components/common/button/MuiButton";
import { MuiDatepicker } from "../../../../components/common/datepicker/MuiDatepicker";
import { MuiTextField } from "../../../../components/common/textfield/MuiTextField";
import routesNames from "../../../../routes/RouteNames";
import strings from "../../../../strings/Strings";
import styles from "./registration.module.css";
import moment from "moment";
import { useEffect, useState } from "react";
import constants from "../../../../core/constants/Constants";
import PhoneNumber from "../../../../components/common/phone-number/PhoneNumber";
import { CreateUserStepperEnumUtils } from "./EmailVerification";
import MuiStepper from "../../../../components/common/stepper/MuiStepper";
import { checkUserNameAvaibilityRequest, createSkillRequest, draftUserData, getAllCategoriesRequest, getAllSkillsRequest, setLoginState } from "../../../../redux/login-redux/LoginRedux";
import { useDispatch, useSelector } from "react-redux";
import CreatableAutocomplete from "../../../../components/common/dropdown/creatable-autocomplete/CreatableAutocomplete";
import { useDebounceFunction } from "../../../../custom/useDebounceFunction";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import Autocomplete from 'react-google-autocomplete';
import ValidationUtils from "../../../../utils/ValidationUtils";

const MobileVerification = ({ activeStep, setActiveStep }) => {

    const dispatch = useDispatch();

    const isMobile = useMediaQuery("(max-width: 839px)");

    const loginState = useSelector((state: any) => state.Login);

    const debounce = useDebounceFunction(
        (callback) => callback(),
        1000
    );

    const navigate = useNavigate();
    const [dateSelected, setDateSelected] = useState(false);
    const [dob, setDob] = useState("");
    const [skills, setSkills] = useState([]);
    const [skillsErr, setSkillsErr] = useState("");
    const [userName, setuserName] = useState('');

    const storeDraftUserData = loginState?.draftUserData;

    const steps = CreateUserStepperEnumUtils.getCreateUserStepperEnums();

    const handleStepClick = (index: number) => {
        if (index < 2) {
            setActiveStep(index);
        }
    };

    const handleUserNameValidation = (value: any) => {
        let errorMessage = "";
        if (!value) {
            errorMessage = strings.pleaseEnterUsername;
        }
        if (ValidationUtils.validateUsername(value)) {
            debounce(() => dispatch(checkUserNameAvaibilityRequest({ profileName: value })));
        } else {
            errorMessage =
                "Username can only include\n• Letters & Numbers (a-z, A-Z, 0-9)\n• Must start with a letter or number\n•  Must not exceed 30 characters\n• Cannot contain the word 'name'\n• Cannot contain only numbers\n• No special characters allowed except for “_” and “.”\n ";
        }
        dispatch(draftUserData({
            ...storeDraftUserData,
            "userName": value?.toLowerCase()?.trim(),
        }))
        dispatch(setLoginState({
            key: "userDetailsErrors",
            value: { ...loginState.userDetailsErrors, "userName": errorMessage },
        }));
    }

    const validateForm = () => {
        let isValid = false;
        if (storeDraftUserData?.userName && dob && storeDraftUserData?.city && skills?.length > 0
            && ValidationUtils.validateUsername(storeDraftUserData?.userName) && loginState?.isProfileNameAvailable === "Username is available") {
            isValid = true;
        }
        else {
            isValid = false;
        }
        return isValid;
    }

    useEffect(() => {
        dispatch(getAllSkillsRequest());
    }, [])

    const handleRoleChange = (values: any) => {
        setSkills(values);
    }

    const handleCreateNewSkills = async (): Promise<boolean> => {
        const skillsName: string[] = [];

        skills?.forEach((skill: any) => {
            if (!skill?.id) {
                skillsName.push(skill?.name ? skill?.name : skill);
            }
        });

        if (skillsName.length > 0) {
            await dispatch(createSkillRequest(skillsName));
            return true;
        }
        else {
            return false;
        }
    };

    useEffect(() => {
        if (loginState?.isSkillAdded) {
            handleNewSkillsAdded();
            dispatch(setLoginState({ key: "isSkillAdded", value: false }));
        }
    }, [loginState?.isSkillAdded])

    const handleNewSkillsAdded = () => {
        let selectedSkills: any[] = skills?.filter((item: any) => item?.id)?.map((item: any) => item?.id) || [];
        let newCreatedSkills: any[] = loginState?.createdSkillsData?.map((item: any) => item?.id) || [];

        setActiveStep(2);
        dispatch(draftUserData({
            ...storeDraftUserData,
            "skillIds": newCreatedSkills.length > 0 && selectedSkills.length > 0 && !selectedSkills.includes(undefined)
                ? selectedSkills.concat(newCreatedSkills)
                : newCreatedSkills.length > 0
                    ? newCreatedSkills
                    : selectedSkills,
        }))
    }


    const handleContinue = async () => {
        let response = await handleCreateNewSkills();

        if (!response)
            handleNewSkillsAdded();
    };

    useEffect(() => {
        dispatch(getAllCategoriesRequest());
    }, [])

    const handlePlaceSelected = (place) => {
        dispatch(draftUserData({
            ...storeDraftUserData,
            "city": place?.formatted_address,
        }))
    };

    return (
        <>
            <Stack direction={"column"} style={{ position: 'relative' }} >
                <Stack
                    direction={"column"}
                    className={styles["container"]}
                >
                    <Stack className={styles["stepper-container"]} flexDirection={"row"} gap={isMobile ? 5 : 11} width={'100%'} alignItems={'center'}>
                        <ArrowBackIosRoundedIcon
                            onClick={() => setActiveStep(0)}
                            className={styles["back-button"]}
                        />
                        <div style={{ width: '60%' }}>
                            <MuiStepper
                                activeStep={activeStep}
                                steps={steps}
                                handleStepClick={handleStepClick}
                            />
                        </div>
                    </Stack>

                    <div>
                        <Typography className={styles["heading"]}>Fill in your basic info</Typography>
                    </div>

                    <Stack flexDirection={'column'} gap={5} className={styles["form-fields"]}>
                        <MuiTextField
                            fullWidth
                            type="text"
                            name="userName"
                            value={storeDraftUserData?.userName}
                            label={strings.enterUserName}
                            inputProps={{ "data-testid": "userName" }}
                            onChange={(e: any) => handleUserNameValidation(e.target.value)}
                            component={"registrationV1"}
                            errormessage={storeDraftUserData?.userName ? loginState?.userDetailsErrors?.userName : ''}
                            helpermessage={storeDraftUserData?.userName ? loginState?.isProfileNameAvailable : ''}
                        />


                        <MuiDatepicker
                            value={
                                dateSelected === false
                                    ? null
                                    : dob ? dob : new Date("2006-01-01")
                            } // Fallback to default value
                            maxdate={moment(new Date()).subtract(13, "years").format()}
                            mindate={moment(new Date()).subtract(80, "years").format()}
                            name="dateOfBirth"
                            label={strings.enterDateOfBirth}
                            inputformat={constants.dateFormat}
                            disablefuture={"true"}
                            inputProps={{ "data-testid": "dateOfBirth" }}
                            onOpen={() => {
                                setDateSelected(true);
                            }}
                            onChange={(e: any) => {
                                setDateSelected(true);
                                setDob(e)
                                dispatch(draftUserData({
                                    ...storeDraftUserData,
                                    "dob": e,
                                }))
                            }}
                            errorMessage=""
                            component={"registrationV1"}
                        />

                        {/* // add city */}
                        <Autocomplete
                            apiKey="AIzaSyA3BTKLox0cwgTnW1CYtkMz1nX1GNbRTRM"
                            onPlaceSelected={handlePlaceSelected}
                            // value={storeDraftUserData?.city || ''}
                            options={{
                                types: ['(cities)'], // You can restrict to specific types
                                // componentRestrictions: { country: 'in' }, // Restrict to India
                            }}
                            className="google-autocomplete"
                            placeholder="Add City"
                            style={{
                                width: '100%', padding: '10px', borderRadius: '20px', height: '5.5rem',
                                backgroundColor: '#0d0d0d', outline: 'none', border: '1px solid #576078', color: '#fff',
                                fontSize: '1.5rem', fontFamily: "Comfortaa-Regular", paddingLeft: '2rem'
                            }}
                        />

                        <CreatableAutocomplete
                            label={'Select skill (Max 6)'}
                            name="roles"
                            dropDownValues={loginState?.allSkills}
                            selectedValues={skills}
                            validateForm={validateForm}
                            handleRoleChange={handleRoleChange}
                            rolesError={skillsErr}
                            inputProps={{ "data-testid": "roles" }}
                        />
                    </Stack>


                    {/* <Stack className={styles["btn-container"]}>
                    </Stack> */}

                    <Stack justifyContent={'center'}>
                        <div style={{ position: 'absolute', bottom: storeDraftUserData?.userName && loginState?.userDetailsErrors?.userName ? isMobile ? '0rem' : '3rem' : isMobile ? '5rem' : '15rem' }}>
                            <MuiButton
                                className={styles["verify"]}
                                onClick={handleContinue}
                                disabled={!validateForm()}
                            >
                                {strings.continue}
                            </MuiButton>
                        </div>
                    </Stack>

                </Stack>
            </Stack>

        </>
    );
}
export default MobileVerification;